(() => {
  // todo use tracking dataSource (would lose current test coverage)

  const getUserImpressionAggregatesRoute = '/common-ui/api/ImpressionTracker/UserImpressionAggregates';

  angular
    .module('kareo.ui.shared.modules.tracking', [])
    .factory('kTrackingService', kTrackingService);

  kTrackingService.$inject = [
    '$cacheFactory',
    '$http'
  ];

  function kTrackingService($cacheFactory, $http) {
    return {
      getUserImpressionAggregates,
      createUserImpression,
      patchUserImpressionTracker,
      dismiss
    };

    function getUserImpressionAggregates() {
      return $http
        .get(getUserImpressionAggregatesRoute, { cache: true })
        .then((response) => response.data);
    }

    function createUserImpression(trackingKey) {
      return $http
        .post('/common-ui/api/ImpressionTracker/' + trackingKey + '/UserImpression')
        .then(invalidateCacheAndReturnResponse);
    }

    function patchUserImpressionTracker(trackingKey, update) {
      return $http
        .patch('/common-ui/api/ImpressionTracker/' + trackingKey + '/UserImpressionTracker', update)
        .then(invalidateCacheAndReturnResponse);
    }

    function dismiss(trackingKey) {
      return patchUserImpressionTracker(trackingKey, { isDismissed: true });
    }

    function invalidateCacheAndReturnResponse(response) {
      $cacheFactory
        .get('$http')
        .remove(getUserImpressionAggregatesRoute);

      return response.data;
    }
  }
})();
